import { NotificationType } from 'src/app/core/common';
import { RoutesConstants } from './routes-constants';

export const NotificationNavigationMap = new Map([
  [NotificationType.EXPORTED_REPORTS, RoutesConstants.EXPORT_REPORTS_PAGE_URL],
  [NotificationType.TEACHER_EDIT_PROFILE_REQUEST, RoutesConstants.UPDATE_TEACHERS_INFO_REQUESTS_PAGE_URL],
]);
